/** Evaluate a skill for a user */

import api from 'api'
import { z } from 'zod'
import { workerRequirementEvaluationStatus } from './typings'

const submitAssessmentRequestSchema = z.object({
  userId: z.number(),
  externalCandidateId: z.string(),
  assessments: z.array(
    z.object({
      workerRequirementId: z.number(),
      status: z.enum(workerRequirementEvaluationStatus),
    })
  ),
  evaluationNote: z.string().nullable().optional(),
})

export type SubmitAssessmentRequest = z.input<
  typeof submitAssessmentRequestSchema
>

/**
 * Pass or fail assessment skills for a user.
 * Creates an admin assessment record for each of the given requirements.
 */
export const submitAssessment = async (request: SubmitAssessmentRequest) => {
  const { userId, externalCandidateId, assessments, evaluationNote } =
    submitAssessmentRequestSchema.parse(request)

  await api.post<void>(`/admin/user/${userId}/assessments`, {
    externalCandidateId,
    assessments,
    ...(evaluationNote !== undefined && { evaluationNote }),
  })
}
